import { AfterViewInit, Component, ContentChild, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { PathFunctionsMap, SeBaseStepContentComponent } from '../se-base-step-content/se-base-step-content.component';

@Component({
    selector: 'se-step',
    templateUrl: './se-step.component.html',
    styleUrls: ['./se-step.component.scss'],
    standalone: false,
})
export class SeStepComponent implements AfterViewInit {
    @Input() title: string = '';
    @Input() name: string = '';

    @Input() readOnly: boolean = false;

    @ViewChild(TemplateRef, { static: true }) content: TemplateRef<SeBaseStepContentComponent> =
        undefined as unknown as TemplateRef<SeBaseStepContentComponent>;

    @ContentChild('content') component: SeBaseStepContentComponent = undefined as unknown as SeBaseStepContentComponent;

    form$: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(new FormGroup({}));
    getObservableValueFunctions$: BehaviorSubject<null | PathFunctionsMap> =
        new BehaviorSubject<null | PathFunctionsMap>(null);
    getControlValue: null | ((path: string) => any) = null;
    getControlValueList: null | ((paths: string[]) => any[]) = null;

    hasError: boolean = false;
    errorMessage: string = '';
    errorsList: string[] = [];
    tooltipMessage: string = '';
    isOptional = false;
    isCompleted = false;

    gotoNextStep$: Subject<string> | null = null;
    currentActiveStep$: BehaviorSubject<string> | null = null;

    ngAfterViewInit() {
        if (!(this.component instanceof SeBaseStepContentComponent)) {
            throw new Error('SeStepComponent must have a child component of type SeBaseStepContentComponent');
        }

        this.component.title = this.title || this.name;
        this.component.name = this.name || this.title;

        this.getObservableValueFunctions$.subscribe((observableFunctions) => {
            if (observableFunctions) {
                this.component.getObservableValueFunctions$.next(observableFunctions);
                this.component.getControlValue = this.getControlValue;
                this.component.getControlValueList = this.getControlValueList;
                this.component.gotoNextStep$ = this.gotoNextStep$;
                this.component.currentActiveStep$ = this.currentActiveStep$;
            }
        });

        this.form$.subscribe((form) => {
            this.component.form$.next(form);
        });

        this.component.isMandatory$.subscribe((isMandatory) => {
            setTimeout(() => {
                this.isOptional = !isMandatory;
            });
        });

        this.component.isValid$.subscribe((isValid) => {
            setTimeout(() => {
                this.isCompleted = isValid;
            });
        });

        this.component.errorsList$.subscribe((errorsList) => {
            setTimeout(() => {
                this.errorsList = errorsList;
                this.hasError = errorsList.length > 0;
                this.errorMessage = `errors: ${errorsList.length}`;
                const errorsCountMap = errorsList.reduce(
                    (acc, errorName) => {
                        if (!acc[errorName]) acc[errorName] = 0;
                        acc[errorName]++;
                        return acc;
                    },
                    {} as Record<string, number>,
                );

                this.tooltipMessage = Object.entries(errorsCountMap)
                    .map(([errorName, count]) => `${errorName}:${count}`)
                    .join('\n');
            });
        });
    }
}
